var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var RespostesFilter = /** @class */ (function (_super) {
    __extends(RespostesFilter, _super);
    function RespostesFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.codi = '';
        _this.descripcio = '';
        _this.acceptacio = null;
        _this.labels['codi'] = _this.i18n('Cód. Respuesta');
        _this.labels['descripcio'] = _this.i18n('Descripción');
        _this.labels['acceptacio'] = _this.i18n('Aceptación');
        return _this;
    }
    return RespostesFilter;
}(FilterData));
export { RespostesFilter };
